module.exports = __webpack_public_path__ + "static/img/contactUS_bg.083150e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/contactUS_bg.svg
// module id = 2YE7
// module chunks = 1